import { render, staticRenderFns } from "./changeStatusStatis.vue?vue&type=template&id=6b9f2369&scoped=true&"
import script from "./changeStatusStatis.vue?vue&type=script&lang=js&"
export * from "./changeStatusStatis.vue?vue&type=script&lang=js&"
import style0 from "./changeStatusStatis.vue?vue&type=style&index=0&id=6b9f2369&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9f2369",
  null
  
)

export default component.exports